import React, { useEffect, useRef, useState } from "react";
//import { resetGetSearchByStoryCache } from "../../app/utils";
//import  {store } from './store'
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import { IconButton, Button, Popper, Box, Popover, TextField, CircularProgress, LinearProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
//import DirectionsIcon from '@mui/icons-material/Directions';
import PushPinIcon from '@mui/icons-material/PushPin';
import HomeIcon from '@mui/icons-material/Home';
import { useSelector, useDispatch } from 'react-redux';
import { /*search,*/ getSearchByTerm, getSearchByCoordinates } from "../../features/searchSlice";


import { useUpdateProfileMutation } from "../../features/profilesSlice";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { AppDispatch, store } from '../../app/store';
//import { showMapFilters } from '../../features/dialogSlice';
import { MapFilterMenu } from './MapFilterMenu';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import NearMeIcon from '@mui/icons-material/NearMe';
import ThreePIcon from '@mui/icons-material/ThreeP';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from '@mui/material/Alert';
import { skipToken } from '@reduxjs/toolkit/query';
import { aiAnalyticsApi, useAskAgentMutation, useGetSearchByStoryQuery } from '../../features/aiAnalytics';
//import { StandaloneSearchBox } from '@react-google-maps/api'
import { setPublicPinClicked } from "../../features/dataProcessingSlice"
import { setAISearch } from "../../features/searchSlice";
import { useSelectAllMarkers } from '../../app/useSelectAllMarkers';
import { activateMarker } from '../../features/activeMarkers';
import { showCareCenters, showWarriors } from '../../features/filterSlice';
import { WidthFull } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import { setBottomSheetState } from "../../features/utilitySlice";
import { setSearchExpanded } from "../../features/dialogSlice";

export function resetGetSearchByStoryCache(refetch: boolean = false): void {
  const queries = store.getState().aiAnalytics.queries;

  Object.values(queries)
    .filter((query: any) => query?.endpointName === 'getSearchByStory')
    .forEach((query: any) => {
      // Clear cached data
      store.dispatch(
        aiAnalyticsApi.util.updateQueryData(
          'getSearchByStory',
          query.originalArgs,
          () => []
        )
      );

      // Optionally refetch
      if (refetch) {
        store.dispatch(
          aiAnalyticsApi.endpoints.getSearchByStory.initiate(
            query.originalArgs,
            { forceRefetch: true }
          )
        );
      }
    });
}

//import { activateMarker } from '../../features/activeMarkers';

enum FormMessageTypes {
  NoResults = 'NoResults',
  MaxCharLimit = "MaxCharLimit",
  noSearchType = 'Please choose search type',
  None = 'none',
  Success = 'success',
  Error = 'error'
}
const formMessages = {
  [FormMessageTypes.NoResults]: { text: 'No results found.', severity: 'info' },
  [FormMessageTypes.MaxCharLimit]: { text: 'You have reached the maximum character limit.', severity: 'info' },
  [FormMessageTypes.None]: { text: '', severity: 'info' },
  [FormMessageTypes.noSearchType]: { text: 'Please choose search type', severity: 'info' },
  [FormMessageTypes.Success]: { text: '', severity: 'info' },
  [FormMessageTypes.Error]: { text: 'Error', severity: 'info' }
}
export const SearchBar: React.FC<{ id: number, lat: number, lng: number, profileLat: number, profileLng: number, formattedSearchTerm: string, zipCode: string, authStatus: string }> =
  ({ id: loggedProfileId, lat, lng, profileLat, profileLng, formattedSearchTerm, zipCode, authStatus }) => {
    const [inputReady, setInputReady] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // Search-bar expanded state lives in Redux (not local) so the map pin-count pill can hide while it's open.
    const showSearchBar = useSelector((state: any) => state.dialog.searchExpanded)
    const [searchType, setSearchType] = React.useState<string>('')
    // const [openSearchTypeSelect, setOpenSearchTypeSelect] = React.useState(false)
    const [formMessage, setFormMessage] = React.useState<FormMessageTypes>(FormMessageTypes.None)
    //const [filterVariant, setFilterVariant] = React.useState<| "contained" | "outlined">("outlined")
    const aiSearchState = useSelector((state: any) => state.search.aiSearch);
    const dispatch = useDispatch<any>();

    const [searchTerm, setSearchTerm] = React.useState('')//need another separate state for args in useGetSearchByStoryQuery, so searchInput could be cleared without triggering useGetSearchByStoryQuery
    //const [searchInput, setSearchInput] = React.useState('') //using ref

    const args = searchTerm ? { id: loggedProfileId, story: searchTerm, authStatus: authStatus } : skipToken// (searchType === 'story' && searchTerm) ? { id: loggedProfileId, story: searchTerm, authStatus: authStatus } : skipToken
    const inputRef = React.useRef<HTMLInputElement | null>(null) as React.MutableRefObject<HTMLInputElement | null>;

    const { data: dataGetSearchByStory, isLoading: isLoadingGetSearchByStory, isSuccess: isSuccessGetSearchByStory, isFetching: isFetchingGetSearchByStory, isUninitialized: isUninitializedGetSearchByStory, isError: isErrorGetSearchByStory } = useGetSearchByStoryQuery(args);
    // const args = searchTerm ? { profileId: loggedProfileId, userPrompt: searchTerm, authStatus: authStatus } : skipToken
    const [askAgent, { data: data, isLoading: isLoadingAskAgent, isSuccess: isSuccessAskAgent, isUninitialized: isUninitializedAskAgent, isError: isErrorAskAgent }] = useAskAgentMutation();
    const { selectAll, snapshotFilters, restoreFilters } = useSelectAllMarkers();

    const [searchParams, setSearchParams] = useSearchParams();
    const formRef = useRef<HTMLFormElement>(null);
    const searchBarText = searchParams.get("sb")
    const removeParam = (key: string) => {
      // clone existing params
      const newParams = new URLSearchParams(searchParams);
      // delete the key
      newParams.delete(key);
      // update URL
      setSearchParams(newParams);
    };

    React.useEffect(() => {
      if (searchBarText && searchBarText.length > 1) {
        // Show search bar
        dispatch(setSearchExpanded(true));

        // If input exists, set its value
        if (inputRef.current) {
          inputRef.current.value = searchBarText;
        }

        // Only submit if input is mounted and form exists
        if (inputReady &&  (inputRef.current?.value ?? '').length > 1 && formRef.current) {
          searchParams.delete("sb");
          setSearchParams(searchParams);

          // Trigger submit
          formRef.current.requestSubmit();
        }
      }
    }, [searchBarText, inputReady, formRef]);


    React.useEffect(() => {
      if (isSuccessAskAgent && !isLoadingAskAgent) {
        // Guard: a successful askAgent response may carry no iterable `askAgentResults` (a clarification, a
        // backend error, or an unexpected shape). Without this, `[...data.askAgentResults]` throws
        // "askAgentResults is not iterable" and the error boundary blanks the whole app. Surface a message
        // instead (mirrors the per-result error path below).
        if (!Array.isArray(data?.askAgentResults)) {
          const agentMsg = (data as any)?.message ?? (data as any)?.clarification ?? (data as any)?.content;
          formMessages[FormMessageTypes.Error].text = agentMsg ?? 'Sorry, we couldn’t process that search. Please try again.';
          setFormMessage(FormMessageTypes.Error);
          restoreFilters();
          return;
        }
        // Sort errors first in place
        const sortedResults = [...data.askAgentResults].sort((a, b) => {
          if (a.status === 'error' && b.status !== 'error') return -1;
          if (a.status !== 'error' && b.status === 'error') return 1;
          return 0;
        });
        const { joinedMessages, hasError } = sortedResults.reduce(
          (acc: { joinedMessages: string; hasError: boolean }, result: any, index: number) => {
            acc.joinedMessages += (index > 0 ? ", " : "") + result.message;
            acc.hasError = acc.hasError || result.status === 'error';
            return acc;
          }, { joinedMessages: "", hasError: false }
        );
        // if (hasError ) {
        //   formMessages[FormMessageTypes.Error].text = joinedMessages
        //   setFormMessage(FormMessageTypes.Error)
        //   restoreFilters();
        //   return
        // }
        //setSearchTerm('')
        resetGetSearchByStoryCache(false)

        //dispatch(aiAnalyticsApi.util.invalidateTags(['AiStorySearch']));
        for (var i = 0; i < sortedResults.length; i++) {
          const dataAskAgent = sortedResults[i];
          if (dataAskAgent?.status === 'error') {
            formMessages[FormMessageTypes.Error].text = dataAskAgent.message
            setFormMessage(FormMessageTypes.Error)
            //setSearchTerm('')
            setSearchType('')
            //continue
          }


          switch (dataAskAgent.function?.name) {
            case "filter_by_their_stories":
              const args = JSON.parse(dataAskAgent.function.arguments);
              if ('search_text' in args) {
                setSearchType('story')
                const newSearchTerm = args.search_text.trim()
                if (!newSearchTerm)
                  continue
                setSearchTerm(newSearchTerm)
                setFormMessage(FormMessageTypes.None)
                dispatch(aiAnalyticsApi.util.invalidateTags(['AiStorySearch']));
                dispatch(setPublicPinClicked(false))
                dispatch(setBottomSheetState(true))
                continue
              }

              break
            case "show_on_map_area":
              if (dataAskAgent?.status === 'error') {
                restoreFilters();
              } else {
                formMessages[FormMessageTypes.Success].text = `${dataAskAgent?.data.pinsCount} pin${dataAskAgent?.data.pinsCount > 1 ? 's' : ''} found`
                setFormMessage(FormMessageTypes.Success)
              }
              if (dataAskAgent?.data?.center && dataAskAgent?.data?.center?.lat && dataAskAgent?.data?.center?.lng) {
                setSearchType('location')
                dispatch(getSearchByCoordinates(dataAskAgent?.data?.center));
              }
              if (dataAskAgent?.data?.radius && dataAskAgent?.data?.center) {//'show_objects' in args) {
                dispatch(setAISearch(true))
              }
              if (!dataAskAgent?.data?.pinsCount) {
                if (dataAskAgent?.data?.pinsCount === 0)
                  setFormMessage(FormMessageTypes.NoResults)
                restoreFilters();
              }
              dispatch(setAISearch(true))
              //selectAll(false)//does dispatch(activateMarker({ id: null, disableHover: false }))
              restoreFilters();
              break;
          }
          // } else {
          //   formMessages[FormMessageTypes.Error].text = "Sorry, I could not find any pins for your search"
          //   setFormMessage(FormMessageTypes.Error)
          //   restoreFilters();
          // }
        }
      }
    }, [isSuccessAskAgent, data, isLoadingAskAgent])

    function useIsWidthUp(breakpoint: any) {
      const theme = useTheme();
      return useMediaQuery(theme.breakpoints.up(breakpoint));
    }

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
      event.preventDefault();
      const form = event.currentTarget;
      setSearchTerm(''); // closes the gate so no render
      if ((inputRef.current?.value ?? '').trim().length === 0) {
        return;
      }
      const args = { profileId: loggedProfileId, userPrompt: inputRef.current!.value.trim() /*searchTerm*/, authStatus: authStatus }
      askAgent(args)
    }

    //const showPin = (lat !== profileLat || lng !== profileLng) && authStatus === 'authenticated'

    const handleFilterClick: (event: React.MouseEvent<HTMLElement>) => void = (event) => {
      //setFilterVariant(anchorEl ?"contained":"outlined"); 
      setAnchorEl(anchorEl ? null : event.currentTarget)
      //dispatch(showMapFilters(true));
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const [offsetTop, setOffsetTop] = React.useState(0);

    useEffect(() => {
      if (inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        setOffsetTop(rect.bottom + 10);
      }
    }, [inputRef.current]); // Run once on mount

    return (<>
      {/* { isLoadingAskAgent && <CircularProgress />  } */}
      <Stack direction="row" gap={1} sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
        {showSearchBar
          ?
          <Stack direction="column" gap={1} sx={{ display: 'flex', width: '100%' }}>
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                flexGrow: 1,
                pointerEvents: 'auto',
                backgroundColor: 'rgba(244, 240, 255, 0.55)',
                backdropFilter: 'blur(24px)',
                WebkitBackdropFilter: 'blur(24px)',
                border: '1px solid rgba(164, 142, 233, 0.18)',
                boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
                borderRadius: 2,
              }}
              component="form"
              onSubmit={handleSubmit}
              ref={formRef}
            >
              {searchType === 'location' &&
                <Paper elevation={0} sx={{ backgroundColor: 'transparent' }}>
                  <IconButton sx={{ color: '#656EFF' }} onClick={() => {
                    //setOpenSearchTypeSelect(true) 
                  }}>
                    <NearMeIcon />
                  </IconButton>
                </Paper>
              }
              {searchType === 'story' &&
                <Paper elevation={0} sx={{ backgroundColor: 'transparent' }}>
                  <IconButton sx={{ color: '#656EFF' }} onClick={() => {
                    //setOpenSearchTypeSelect(true) 
                  }}>
                    <ThreePIcon />
                  </IconButton>
                </Paper>
              }
              {searchType.length > 0 &&
                <Divider orientation="vertical" />
              }

              <InputBase
                disabled={isLoadingAskAgent}

                inputRef={(el) => {
                  inputRef.current = el;
                  if (el && !inputReady) {
                    setInputReady(true);
                  }
                }}

                id='search-bar'
                // value={searchInput}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  let val = event.target.value;
                  if (val.length > 200) {
                    setFormMessage(FormMessageTypes.MaxCharLimit)
                    if (inputRef.current) inputRef.current.value = val.slice(0, 200);
                    return;
                  } else {
                    if (!event.target.value?.trim()) {
                      if (inputRef.current && inputRef.current.value !== val) {
                        inputRef.current.value = val;
                      }
                      restoreFilters();
                      dispatch(setAISearch(false));
                    }
                    //setSearchInput(event.target.value)
                    if (formMessage !== FormMessageTypes.None) setFormMessage(FormMessageTypes.None)
                  }
                }}

                // onClick={() => { searchType.length == 0 ? setOpenSearchTypeSelect(true) : setOpenSearchTypeSelect(false) }}
                sx={{ ml: 1, flexGrow: 1 }}
                placeholder={searchType === 'location' ? 'Search an address' : searchType === 'story' ? 'Search a patient story' : 'Click to choose search type'}
                inputProps={{ 'aria-label': 'search map', autoComplete: 'off' }}
              />

              <Divider orientation="vertical" />
              <IconButton disabled={isLoadingAskAgent} sx={{ color: '#656EFF' }} type="submit" aria-label="search" >
                <SearchIcon />
              </IconButton>
              <Divider orientation="vertical" />
              <IconButton disabled={isLoadingAskAgent} sx={{ color: '#656EFF' }} onClick={() => {
                dispatch(setSearchExpanded(false));
                //setOpenSearchTypeSelect(false);
                setSearchType('');
                setFormMessage(FormMessageTypes.None);
                //if (aiSearchState) {
                //selectAll(true)
                restoreFilters();
                //}
                dispatch(setAISearch(false));
              }} aria-label="close search bar" >
                <CloseFullscreenIcon />
              </IconButton>
              {isLoadingAskAgent && <LinearProgress />}
            </Paper>
            <Box >
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={10000}
                onClose={() => setFormMessage(FormMessageTypes.None)}
                open={formMessage !== FormMessageTypes.None}
                sx={{ top: `${offsetTop}px !important`, }}
              >
                <Alert
                  severity={formMessages[formMessage].severity as AlertColor}
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {formMessages[formMessage].text}
                </Alert>
              </Snackbar>
            </Box>
          </Stack>
          :
          <Paper elevation={0} sx={{
            pointerEvents: 'auto',
            maxWidth: '40px', maxHeight: '40px', minWidth: '40px', minHeight: '40px',
            backgroundColor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            border: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
            '&:hover': { backgroundColor: 'rgba(244, 240, 255, 0.7)' },
          }}>
            <IconButton onClick={() => {
              dispatch(setSearchExpanded(true));
              //setOpenSearchTypeSelect(true)
              snapshotFilters();
              //selectAll(false)
            }} sx={{ color: '#656EFF' }} aria-label="search" >
              <SearchIcon />
            </IconButton>
          </Paper>
        }
        <Box sx={{ pointerEvents: 'auto' }}>
          <Paper elevation={0} sx={{
            maxWidth: '40px', maxHeight: '40px', minWidth: '40px', minHeight: '40px',
            backgroundColor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            border: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
            '&:hover': { backgroundColor: 'rgba(244, 240, 255, 0.7)' },
          }}>
            <IconButton sx={{ color: '#656EFF' }} onClick={handleFilterClick} aria-label="Filter" >
              <FilterAltIcon />
            </IconButton>
          </Paper>
          <Popover elevation={0} id={loggedProfileId?.toString()} open={Boolean(anchorEl)} sx={{ zIndex: 200, '& .MuiPaper-root': { backgroundColor: 'rgba(244, 240, 255, 0.55)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)', border: '1px solid rgba(164, 142, 233, 0.18)', boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)', borderRadius: 2 } }} onClose={(event: React.MouseEvent<HTMLElement>) => setAnchorEl(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            anchorEl={anchorEl}
          >
            <MapFilterMenu />
          </Popover>
        </Box>
      </Stack>
      {isLoadingAskAgent && <LinearProgress sx={{ mt: '-15px' }} />}
    </>
    );
  }
